import requestListService from '@/services/materialCatalogingRequest/requestListService';
import formConfigService from '@/services/materialCatalogingRequest/formConfigService';
import formConfigHelper from '@/helpers/New_formConfig';

const savedMapHardcode = (() => {
  try { return JSON.parse(localStorage.getItem('mapHardcodeMcr')) || null; } catch { return null; }
})();

const savedCataloguingFormConfig = (() => {
  try { return JSON.parse(localStorage.getItem('cataloguingFormConfig')) || null; } catch { return null; }
})();

const state = {
  isLoading: { header: false, items: false },
  mcrHeader: { id: null, subject: '', status: '', type: '', mcr_number: '', created_by: '', created_at: '' },
  allMcrItem: [],
  setErrorValidCat: [],
  selectedMcrItem: null,
  lastSavedAt: null,
  mapHardcodeMcr: savedMapHardcode,
  cataloguingFormConfig: savedCataloguingFormConfig,
  itemFormConfigs: {},
  storeMapSprCatLotszMrp: {},
  storeMapPurchGrp: {},
  storeMapWarehouse: {},
  lockedMcrItemCode: null,
  checkDuplicateDialog: {
    leftCard: { data: [], total: 0, loading: false },
    rightCard: { data: [], total: 0, loading: false },
  },

  // TAMBAHAN BY DAP (NEW DESIGN)
  mcrDetail: {
    mcrHeader: null,
    mcrFormType: null,
    mcrFormAccess: null,
    formConfig: null,
    // Mode route yang membuka form MCR ('edit' | 'view', dari meta.formMode -- diset New_McrForm). Dibaca getFormCode
    // untuk baris mcr_form_type ber-`form_mode`, mis. send_back: Material Request List (view) FORM02, My Task (edit) FORM01.
    formMode: 'edit',
  }
};

// `status`/`role` di setting boleh string, array, atau '*' (default semua). Baris tanpa key dianggap '*'.
const asList = (value) => [].concat(value ?? '*').map(v => String(v).toLowerCase());

// Resolve 'edit' | 'view' dari mcr_form_access. Pure function supaya bisa dipakai ulang
// (mis. daftar mcr_type yang boleh di-create: resolveFormAccess(rows, type, roles, 'draft')).
// Prioritas: status persis > status '*'; di dalam tiap tingkat, role user > role '*'.
// Beberapa role: paling longgar menang. Tidak ada baris yang cocok -> 'view' (default aman).
const resolveFormAccess = (accessRows, mcrType, userRoles, status) => {
  const roles = (userRoles || []).map(r => String(r).toLowerCase());
  const st = String(status ?? '').toLowerCase();
  const ofType = (accessRows || []).filter(r => r.mcr_type === mcrType);

  const pick = (rows) => {
    const exact = rows.filter(r => asList(r.role).some(x => roles.includes(x)));
    return exact.length ? exact : rows.filter(r => asList(r.role).includes('*'));
  };

  const bySpecific = st ? pick(ofType.filter(r => asList(r.status).includes(st))) : [];
  const candidates = bySpecific.length ? bySpecific : pick(ofType.filter(r => asList(r.status).includes('*')));

  if (!candidates.length) return 'view';
  return candidates.some(r => (r.access ?? 'edit') === 'edit') ? 'edit' : 'view';
};

const getters = {
  getFormCode: (state) => {
    const rows = (state.mcrDetail.mcrFormType || []).filter(
        item => item.mcr_type === state.mcrHeader?.type
    );
    const status = String(state.mcrHeader?.status ?? '').toLowerCase();
    const mode = String(state.mcrDetail.formMode || 'edit').toLowerCase();

    // `status` & `form_mode` di setting: string, array string, atau '*' (tanpa key = '*', semua). Status persis menang
    // atas '*'; di dalam tiap tingkat, form_mode persis menang atas '*'. Baris yang form_mode-nya tidak cocok dilewati.
    const forMode = (list) => {
      const exact = list.filter(item => asList(item.form_mode).includes(mode));
      return exact.length ? exact : list.filter(item => asList(item.form_mode).includes('*'));
    };
    const bySpecific = status ? forMode(rows.filter(item => asList(item.status).includes(status))) : [];
    return bySpecific[0] || forMode(rows.filter(item => asList(item.status).includes('*')))[0] || undefined;
  },
  // SATU sumber "form MCR boleh diedit": route bukan mode lihat-saja (meta.formMode 'view' -> mcrDetail.formMode) DAN
  // mcr_form_access = 'edit' (role user + status + mcr_type header). Dipakai New_McrItem (readonly form -> semua input &
  // tombol tambah/hapus baris di tab) dan New_McrFooter (tombol Save Cataloguer / Save Draft ANTAM).
  isFormEditable: (state, getters) => {
    if (String(state.mcrDetail.formMode || 'edit').toLowerCase() === 'view') return false;
    return getters.getFormAccess === 'edit';
  },
  // Daftar kode mcr_type yang boleh dibuat (create draft)
  getCreatableMcrTypes: (state, getters, rootState) => {
    const rows = state.mcrDetail.mcrFormAccess || [];
    const roles = rootState.auth.userHasRoles || [];
    const types = [...new Set(rows.map(r => r.mcr_type))];
    return types.filter(type => resolveFormAccess(rows, type, roles, 'draft') === 'edit');
  },
  getFormAccess: (state, getters, rootState) => {
    return resolveFormAccess(
      state.mcrDetail.mcrFormAccess,
      state.mcrHeader?.type,
      rootState.auth.userHasRoles,
      state.mcrHeader?.status,
    );
  },
}

const mutations = {
  setMcrHeader(state, data) {
    state.mcrHeader = { ...state.mcrHeader, ...data };
  },
  setHeaderLoading(state, bool) {
    state.isLoading.header = bool;
  },
  setAllMcrItem(state, allMcrItem) {
    state.allMcrItem = [...allMcrItem];
    // selectedMcrItem WAJIB tetap elemen allMcrItem (satu objek, bukan dua salinan yang tidak sinkron): kalau
    // daftar diganti objek baru, penunjuk diarahkan ulang ke elemen ber-id sama. Item terpilih yang tidak ada lagi
    // di daftar dibiarkan -- pemanggil yang mengosongkan seleksi (mis. New_CataloguerForm.resetSelection).
    const selected = state.selectedMcrItem;
    if (selected?.id == null) return;
    const match = state.allMcrItem.find((item) => item?.id === selected.id);
    if (match && match !== selected) state.selectedMcrItem = match;
  },
  setSelectedMcrItem(state, item) {
    state.selectedMcrItem = item;
  },
  // Update sebagian field SATU item di allMcrItem (mis. notes/status dari UserForm) tanpa mengganti
  // objeknya -- referensi yang dipegang komponen lain (selectedMcrItem) tetap valid. Dipakai form
  // yang item-nya dibaca dari store supaya tidak memutasi state Vuex langsung dari komponen.
  patchMcrItem(state, { mcr_item_code, patch }) {
    const item = state.allMcrItem.find((i) => i?.mcr_item_code === mcr_item_code);
    if (!item || !patch) return;
    Object.assign(item, patch);
  },
  setAddItemMcrInCertObj(state, { idSelectedMcr, objectName, index, dataAdded }) {
    const targetItem = state.allMcrItem.find(w => w.id === idSelectedMcr);
    if (targetItem) {
      if (!targetItem[objectName]) {
        targetItem[objectName] = [];
      }
      targetItem[objectName].splice(index, 0, dataAdded);
    }
  },
  setDeleteItemMcrInCertObj(state, { idSelectedMcr, objectName, index }) {
    const targetCertMrp = state.allMcrItem.find(w => w.id === idSelectedMcr);
    if (targetCertMrp) targetCertMrp[objectName].splice(index, 1);
  },
  setAddValidationErrorAllMcrItemCat(state, data) {
    state.setErrorValidCat = data;
  },
  setAddCertainRowInErrValidation(state, { idxMcrItem, subTab, indexRowTab }) {
    if (state.setErrorValidCat && state.setErrorValidCat[idxMcrItem] && state.setErrorValidCat[idxMcrItem][subTab]) {
      state.setErrorValidCat[idxMcrItem][subTab].splice(indexRowTab, 0, {})
    }
  },
  setDeleteErrorValidationAllMcrItemCat(state) {
    state.setErrorValidCat = [];
  },
  setLastSavedAt(state) {
    state.lastSavedAt = Date.now();
  },
  setMapHardcodeMcr(state, data) {
    state.mapHardcodeMcr = data;
    localStorage.setItem('mapHardcodeMcr', JSON.stringify(data));
  },
  setMapSprCatLotszMrp(state, data) {
    state.storeMapSprCatLotszMrp = data;
  },
  setMapPurchGrp(state, data) {
    state.storeMapPurchGrp = data;
  },
  setMapWarehouse(state, data) {
    state.storeMapWarehouse = data;
  },
  setCataloguingFormConfig(state, config) {
    state.cataloguingFormConfig = config;
    state.itemFormConfigs = {};
    if (config === null) {
      localStorage.removeItem('cataloguingFormConfig');
    } else {
      localStorage.setItem('cataloguingFormConfig', JSON.stringify(config));
    }
  },
  setCataloguingFormConfigTransient(state, config) {
    state.cataloguingFormConfig = config;
    state.itemFormConfigs = {};
  },
  initItemFormConfig(state, mcr_item_code) {
    if (!state.cataloguingFormConfig || !mcr_item_code) return;
    state.itemFormConfigs = {
      ...state.itemFormConfigs,
      [mcr_item_code]: JSON.parse(JSON.stringify(state.cataloguingFormConfig))
    };
  },
  updateCataloguingFormConfigField(state, { path, value, mcr_item_code }) {
    const code = mcr_item_code || state.selectedMcrItem?.mcr_item_code;
    if (!code || !state.itemFormConfigs?.[code]?.tab_fields) return;
    const keys = [...path];
    const lastKey = keys.pop();
    let target = state.itemFormConfigs[code].tab_fields;
    for (const key of keys) {
      if (target[key] == null) return;
      target = target[key];
    }
    target[lastKey] = value;
  },
  setLockedMcrItemCode(state, code) {
    state.lockedMcrItemCode = code;
  },
  setCheckDuplicateLoading(state, { card, value }) {
    state.checkDuplicateDialog[card].loading = value;
  },
  setCheckDuplicateData(state, { card, data }) {
    state.checkDuplicateDialog[card].data = data;
    state.checkDuplicateDialog[card].total = data.length;
  },
  resetCheckDuplicateDialog(state) {
    state.checkDuplicateDialog.leftCard = { data: [], total: 0, loading: false };
    state.checkDuplicateDialog.rightCard = { data: [], total: 0, loading: false };
  },
  setDelCertErrVal(state, { formUsedFor, field, idxMcrItem, subTab, indexRowTab }) {
    if (formUsedFor == 'cataloguer') {
      if (idxMcrItem === undefined || state.setErrorValidCat.length === 0) return;
      const itemErr = state.setErrorValidCat[idxMcrItem];
      if (!itemErr) return;
      if (subTab == "" && indexRowTab == null) {
        delete itemErr[field];
      } else if (field !== "") {
        if (!itemErr[subTab]?.[indexRowTab]) return;
        delete itemErr[subTab][indexRowTab][field];
      } else {
        if (!itemErr[subTab]) return;
        itemErr[subTab].splice(indexRowTab, 1);
      }
    }
  },

  // TAMBAHAN BY DAP (NEW DESIGN)
  setMcrFormType(state, payload) {
    state.mcrDetail.mcrFormType = payload
  },
  setMcrFormAccess(state, payload) {
    state.mcrDetail.mcrFormAccess = payload
  },
  setFormConfig(state, data) {
    state.mcrDetail.formConfig = data;
  },
  setFormMode(state, mode) {
    state.mcrDetail.formMode = mode === 'view' ? 'view' : 'edit';
  },
};

const actions = {
  storeMcrHeader({ commit }, data) {
    commit('setMcrHeader', data);
  },
  // Detail MCR + item SELALU dari request list (request-pool/request-list/{id}) -- endpoint itu
  // `find($id)` tanpa filter status, jadi draft maupun non-draft terlayani dari sumber yang sama;
  // draft-list cuma dipakai halaman Draft List. Parameter `isDraft` dihapus: dulu default-nya `true`
  // sehingga caller yang lupa mengirimnya diam-diam mengambil data dari draft-list.
  async fetchMcrHeader({ commit }, { id }) {
    commit('setHeaderLoading', true);
    try {
      const res = await requestListService.detail(id);
      const data = res.data.data;
      const type = data?.type;
      const normalizedType = (type || '').toLowerCase().replace(/\s+/g, '-');
      const emcrItems = data?.emcr_item || [];
      const specialTypes = ['MCR003', 'MCR004', 'MCR005', 'MCR006', 'MCR007', 'MCR010'];
      
      if (specialTypes.includes(type) || specialTypes.includes(normalizedType)) {
        if (emcrItems.length > 0) {
          const mapped = emcrItems.map(item => {
            if (normalizedType === 'flag-unflag' || normalizedType === 'mcr005') {
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                material_number: item.material_number || '',
                flag_unflag: item.flag_unflag || '',
                level: item.level || '',
                plant: item.plant || '',
                valuation_type: item.cat_valuation_type || '',
                storage_location: item.cat_storage_location || '',
                warehouse_number: item.cat_warehouse_number || '',
                storage_type: item.cat_storage_type || '',
                notes: item.notes || '',
                plantOptions: item.plantOptions || [],
                valuationTypeOptions: item.valuationTypeOptions || [],
                storageLocationOptions: item.storageLocationOptions || [],
                warehouseOptions: item.warehouseOptions || [],
                storageTypeOptions: item.storageTypeOptions || [],
              };
            } else if (normalizedType === 'block-unblock' || normalizedType === 'mcr004') {
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                material_number: item.material_number || '',
                material_type: (item.material_type && typeof item.material_type === 'object' ? item.material_type.code : item.material_type) || '',
                block_unblock: item.block_unblock || '',
                level: item.level || '',
                manufacturer: item.manufacturer || '',
                manufacturerOptions: item.manufacturerOptions || [],
                block_reason: item.block_reason || '',
                plant: item.plant || '',
                notes: item.notes || '',
              };
            } else if (normalizedType === 'consolidation' || normalizedType === 'mcr006') {
              // Data untuk CONSOLIDATION MATERIAL (MCR006) dipetakan dengan NAMA KOLOM CONFIG
              // FORM08 (cons_mat_from/cons_mat_to/specification) supaya form engine generik bisa
              // baca/tulis langsung lewat `dialog.form[column]`. `_raw` = nilai material asli
              // yang dipakai AutoComplete sebagai nilai kirim ke API.
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                cons_mat_from: item.cons_mat_from || '',
                cons_mat_from_raw: item.cons_mat_from || '',
                cons_mat_to: item.cons_mat_to || '',
                cons_mat_to_raw: item.cons_mat_to || '',
                specification: item.specification || '',
              };
            } else if (normalizedType === 'mrp') {
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                material_number: item.material_number || '',
                plant: item.plant || '',
                mrp_type: item.cat_mrp_type || '',
                mrp_group: item.cat_mrp_group || '',
                mrp_controller: item.cat_mrp_controller || '',
                gr_processing_time: item.cat_gr_processing_time ?? null,
                planned_delivery: item.cat_planned_delivery ?? null,
                reorder_point: item.cat_reorder_point ?? null,
                safety_stock: item.cat_safety_stock ?? null,
                lot_size: item.cat_lot_size || '',
                max_lotsize: item.cat_max_lotsize ?? null,
                min_lotsize: item.cat_min_lotsize ?? null,
                max_stock: item.cat_max_stock ?? null,
                special_procurement_type: item.cat_special_procurement_type || '',
                sloc_for_ep: item.cat_sloc_for_ep || '',
              };
            } else if (normalizedType === 'mass-update-mrp' || normalizedType === 'mcr007') {
              // Data untuk MASS UPDATE (MCR007) dipetakan dengan NAMA KOLOM CONFIG FORM06
              // (material_number/material_type/plant + mu_*), sama seperti FORM03/04 — supaya
              // form engine generik bisa baca/tulis langsung lewat `dialog.form[column]`.
              // Nilai lama mu_old_* ikut dibawa tapi cuma untuk tampilan (tidak dikirim ke BE).
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                material_number: item.material_number || '',
                material_type: (item.material_type && typeof item.material_type === 'object' ? item.material_type.code : item.material_type) || item.cat_material_type || '',
                plant: item.plant || item.cat_plant || '',
                mu_mrp_type: item.mu_mrp_type || item.cat_mrp_type || '',
                mu_mrp_group: item.mu_mrp_group || item.cat_mrp_group || '',
                mu_reorder_point: item.mu_reorder_point ?? 0,
                mu_lot_size: item.mu_lot_size || item.cat_lot_size || '',
                mu_abc_indicator: item.mu_abc_indicator || item.cat_abc_indicator || '',
                mu_min_lot_size: item.mu_min_lot_size ?? 0,
                mu_max_lot_size: item.mu_max_lot_size ?? 0,
                mu_max_stock: item.mu_max_stock ?? 0,
                mu_rounding_value: item.mu_rounding_value ?? 0,
                mu_special_procurement: item.mu_special_procurement || item.cat_special_procurement_type || '',
                mu_unit_price: item.mu_unit_price ?? 0,
                mu_safety_stock: item.mu_safety_stock ?? 0,
                mu_planned_delivery_time: item.mu_planned_delivery_time ?? 0,
                mu_material_freight_group: item.mu_material_freight_group || '',
                // Field TIMAH-only; wajib ikut dipetakan, kalau tidak nilainya hilang
                // saat item di-load dari API (dan ikut ter-null saat user menyimpan form).
                mu_storage_location: item.mu_storage_location || '',
                mu_bin_location: item.mu_bin_location || '',
                mu_uom: item.mu_uom || '',
                mu_old_mrp_type: item.mu_old_mrp_type || '',
                mu_old_mrp_group: item.mu_old_mrp_group || '',
                mu_old_reorder_point: item.mu_old_reorder_point ?? 0,
                mu_old_lot_size: item.mu_old_lot_size || '',
                mu_old_abc_indicator: item.mu_old_abc_indicator || '',
                mu_old_min_lot_size: item.mu_old_min_lot_size ?? 0,
                mu_old_max_lot_size: item.mu_old_max_lot_size ?? 0,
                mu_old_max_stock: item.mu_old_max_stock ?? 0,
                mu_old_rounding_value: item.mu_old_rounding_value ?? 0,
                mu_old_special_procurement: item.mu_old_special_procurement || '',
                mu_old_unit_price: item.mu_old_unit_price ?? 0,
                mu_old_safety_stock: item.mu_old_safety_stock ?? 0,
                mu_old_planned_delivery_time: item.mu_old_planned_delivery_time ?? 0,
                mu_old_material_freight_group: item.mu_old_material_freight_group || '',
                mu_old_storage_location: item.mu_old_storage_location || '',
                mu_old_bin_location: item.mu_old_bin_location || '',
                mu_old_uom: item.mu_old_uom || '',
              };			
            } else if (normalizedType === 'change-master-data' || normalizedType === 'mcr010') {
              // Data untuk CHANGE MASTER DATA (MCR010) dipetakan dengan NAMA KOLOM CONFIG FORM07
              // (change_md_type/specification) supaya form engine generik bisa baca/tulis langsung
              // lewat `dialog.form[column]`.
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                change_md_type: item.change_md_type || '',
                specification: item.specification || '',
              };
            } else if (normalizedType === 'extend' || normalizedType === 'mcr003') {
              // Data untuk EXTEND-MATERIAL (MCR003) menggunakan field ext_* dari API response
              const firstValuation = Array.isArray(item.emcr_item_valuation) && item.emcr_item_valuation.length
                ? item.emcr_item_valuation[0] : {};
              return {
                id: item.id,
                // Dibaca langsung dari item oleh daftar item New_UserForm (FORM01) & New_CataloguerForm (FORM02) serta
                // tombol item (badge status, Cancel, Check Duplicate) -- tanpa ini kolomnya kosong untuk MCR003.
                material_type: item.material_type || '',
                material_group: item.material_group || '',
                uom: item.uom || '',
                specification: item.specification || '',
                status: item.status || '',
                catalogued_by: item.catalogued_by || null,
                cat_inc: item.cat_inc || '',
                cat_item_type: item.cat_item_type || '',
                cat_short_description: item.cat_short_description || '',
                cat_po_horizontal: item.cat_po_horizontal || '',
                cat_emcr_item_manufacturer: item.cat_emcr_item_manufacturer || [],
                catalog_inc: item.catalog_inc || null,
                catalog_uom: item.catalog_uom || null,
                catalog_material_type: item.catalog_material_type || null,
                catalog_material_group: item.catalog_material_group || null,
                mcr_item_code: item.mcr_item_code,
                material_number: item.material_number || '',
                // Basic fields
                plant: item.ext_plant || item.plant || '',
                valuation_type: item.ext_valuation_type || '',
                storage_location: item.ext_location || item.storage_location || '',
                storage_bin: item.cat_storage_bin || '',
                // Organization Level (ext_* prefix sesuai response API)
                ext_plant: item.ext_plant || '',
                ext_location: item.ext_location || '',
                ext_valuation_type: item.ext_valuation_type || '',
                ext_sales_org: item.ext_sales_org || '',
                ext_dist_channel: item.ext_dist_channel || '',
                ext_warehouse_number: item.ext_warehouse_number || '',
                ext_storage_type: item.ext_storage_type || '',
                // Copy From fields
                ext_cf_plant: item.ext_cf_plant || '',
                ext_cf_location: item.ext_cf_location || '',
                ext_cf_valuation_type: item.ext_cf_valuation_type || '',
                ext_cf_sales_org: item.ext_cf_sales_org || '',
                ext_cf_dist_channel: item.ext_cf_dist_channel || '',
                ext_cf_warehouse_number: item.ext_cf_warehouse_number || '',
                ext_cf_storage_type: item.ext_cf_storage_type || '',
                // Accounting fields (dari emcr_item_valuation)
                price_control: firstValuation.price_control || item.cat_price_control || '',
                price_unit: item.cat_price_unit != null ? Number(item.cat_price_unit) : 1,
                currency: item.cat_currency || 'IDR',
                price: firstValuation.std_price != null ? Number(firstValuation.std_price) : (item.cat_price != null ? Number(item.cat_price) : 0),
                // Nested arrays (diteruskan untuk keperluan McrItemFormDialog openForEdit)
                emcr_item_valuation: item.emcr_item_valuation || [],
                emcr_item_plant: item.emcr_item_plant || [],
                emcr_item_manufacturer: item.emcr_item_manufacturer || [],
                emcr_item_attachment: item.emcr_item_attachment || [],
                // ANTAM: validasi attachment footer (New_McrFooter.validateAttachments) membaca cat_emcr_item_attachment.
                cat_emcr_item_attachment: item.cat_emcr_item_attachment || [],
                emcr_item_note: item.emcr_item_note || [],
                emcr_item_equipment: item.emcr_item_equipment || [],
                // cat_* fields for cataloguer
                cat_mrp_type: item.cat_mrp_type || '',
                cat_mrp_group: item.cat_mrp_group || '',
                cat_plant: item.cat_plant || '',
                cat_storage_location: item.cat_storage_location || '',
                cat_valuation_type: item.cat_valuation_type || '',
                cat_price_control: item.cat_price_control || '',
                cat_price: item.cat_price != null ? Number(item.cat_price) : null,
                cat_price_unit: item.cat_price_unit != null ? Number(item.cat_price_unit) : null,
                cat_currency: item.cat_currency || '',
              };
            } else if (normalizedType === 'update-price') {
              return {
                id: item.id,
                mcr_item_code: item.mcr_item_code,
                material_number: item.material_number || '',
                plant: item.plant || item.cat_plant || '',
                valuation_type: item.cat_valuation_type || '',
                price_control: item.cat_price_control || '',
                price_unit: item.cat_price_unit != null ? Number(item.cat_price_unit) : 1,
                currency: item.cat_currency || 'IDR',
                old_price: item.cat_old_price != null ? Number(item.cat_old_price) : 0,
                price: item.cat_price != null ? Number(item.cat_price) : 0,
              };
            }				  
          });
          commit('setAllMcrItem', mapped);
        } else {
          // Reset ke array kosong jika semua item sudah dihapus
          commit('setAllMcrItem', []);
        }
      } else {
        commit('setAllMcrItem', emcrItems);
      }
      commit('setMcrHeader', data);
    } finally {
      commit('setHeaderLoading', false);
    }
  },
  setLockedMcrItemCode({ commit }, code) {
    commit('setLockedMcrItemCode', code);
  },
  storeAllMcrItem({ commit }, data) {
    commit('setAllMcrItem', data);
  },
  addItemMcrInCertObj({ commit }, { idSelectedMcr, objectName, index, dataAdded }) {
    commit('setAddItemMcrInCertObj', { idSelectedMcr, objectName, index, dataAdded });
  },
  deleteItemMcrInCertObj({ commit }, { idSelectedMcr, objectName, index }) {
    commit('setDeleteItemMcrInCertObj', { idSelectedMcr, objectName, index });
  },
  storeSelectedMcrItem({ commit }, item) {
    commit('setSelectedMcrItem', item);
  },
  addValidationErrorAllMcrItemCat({ commit }, { data }) {
    commit('setAddValidationErrorAllMcrItemCat', data);
  },
  addCertainRowInErrValidation({ commit }, { idxMcrItem, subTab, indexRowTab }) {
    commit('setAddCertainRowInErrValidation', { idxMcrItem, subTab, indexRowTab });
  },
  deleteErrorValidationAllMcrItemCat({ commit }) {
    commit('setDeleteErrorValidationAllMcrItemCat');
  },
  deleteCertainErrorValidation({ commit }, { formUsedFor, field, idxMcrItem, subTab, indexRowTab }) {
    commit('setDelCertErrVal', { formUsedFor, field, idxMcrItem, subTab, indexRowTab });
  },
  triggerRefresh({ commit }) {
    commit('setLastSavedAt');
  },
  storeMapHardcodeMcr({ commit }, data) {
    commit('setMapHardcodeMcr', data);
  },
  storeSprCatLotszMrp({ commit }, data) {
    commit('setMapSprCatLotszMrp', data);
  },
  setCataloguingFormConfig({ commit }, data) {
    commit('setCataloguingFormConfig', data);
  },
  setCataloguingFormConfigTransient({ commit }, data) {
    commit('setCataloguingFormConfigTransient', data);
  },
  initItemFormConfig({ commit }, mcr_item_code) {
    commit('initItemFormConfig', mcr_item_code);
  },
  updateCataloguingFormConfigField({ commit }, { path, value, mcr_item_code }) {
    commit('updateCataloguingFormConfigField', { path, value, mcr_item_code });
  },
  // Olah data mentah hasil check-duplicate/description (sudah difetch di component) menjadi bentuk leftCard
  processDuplicateDescription({ commit }, rawRows) {
    const rows = Array.isArray(rawRows) ? rawRows : [];
    const mapped = rows.map((row) => ({
      id: row.id,
      material_number: row.material_number || '',
      long_description: row.po_text_horizontal || '',
      short_description: row.short_description || '',
      company: row.company || '',
      similarity: Number(row.similarity) || 0,
      material_type: row.material_type?.code || '',
      material_type_description: row.material_type?.label || row.material_type?.description || '',
      material_group: row.material_group?.code || '',
      material_group_description: row.material_group?.label || row.material_group?.description || '',
      uom: row.uom || '',
      uom_description: row.uom_data?.label || row.uom_data?.description || row.uom || '',
      created_at: row.created_at || null,
    }));
    commit('setCheckDuplicateData', { card: 'leftCard', data: mapped });
    return mapped;
  },
  // Olah data mentah hasil check-duplicate/part_number (sudah difetch di component) menjadi bentuk rightCard (grouped by manufacture/spn)
  processDuplicatePartNumber({ commit }, rawRows) {
    const rows = Array.isArray(rawRows) ? rawRows : [];
    const mapped = rows.map((group, index) => ({
      id: `${group.manufacture || 'na'}-${group.spn || 'na'}-${index}`,
      manufacture: group.manufacturer?.code && group.manufacturer?.name ? `${group.manufacturer?.code} - ${group.manufacturer?.name}` : group.manufacturer || '',
      spn: group.spn || '',
      duplicate_count: (group.duplicates || []).length,
      duplicates: (group.duplicates || []).map((dup) => ({
        id: dup.id,
        manufacture_material_number: group.manufacture && dup.material_number ? `${group.manufacture} - ${dup.material_number}` : '',
        material_number: dup.material_number || '',
        long_description: dup.po_text_horizontal || '',
        material_type: dup.material_type?.code || '',
        material_type_description: dup.material_type?.label || dup.material_type?.description || '',
        material_group: dup.material_group?.code || '',
        material_group_description: dup.material_group?.label || dup.material_group?.description || '',
        uom: dup.uom || '',
        uom_description: dup.uom_data?.label || dup.uom_data?.description || dup.uom || '',
        company: dup.company?.code || '',
        company_description: dup.company?.label || dup.company?.description || '',
      })),
    }));
    commit('setCheckDuplicateData', { card: 'rightCard', data: mapped });
    return mapped;
  },

  // TAMBAHAN BY DAP (NEW DESIGN)
  async fetchMcrFormType({ commit, rootState }) {
    const res = await formConfigService.get("mcr_form_type");
    const filtered = res.data.data.data.filter(
      item => item.company === rootState.auth.user.company_code
    )
    commit('setMcrFormType', filtered)
  },
  async fetchMcrFormAccess({ commit, rootState }) {
    const res = await formConfigService.get("mcr_form_access");
    const filtered = res.data.data.data.filter(
      item => item.company === rootState.auth.user.company_code
    )
    commit('setMcrFormAccess', filtered)
  },
  async fetchFormConfig({ commit }, formCode) {
    const res = await formConfigService.New_getFormConfig({ form_code: formCode });
    const raw = res?.data?.data || res?.data;
    const config = formConfigHelper.normalizeFormConfig(raw);
    commit('setFormConfig', config);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
